module.exports = __webpack_public_path__ + "fonts/Catamaran-ExtraLight.fbc8307e.woff";